import { DateTime } from 'luxon';

export const STORAGE_KEY = 'subscriptionSessionReview';

export type SubscriptionSessionReview = {
  userId: string;
  sessionId: string;
  sessionStartTimestamp: number;
  isOpen: boolean;
};

export const getReviewedSessions = (): SubscriptionSessionReview[] => {
  const subscriptionSessionReview = localStorage.getItem(STORAGE_KEY) ?? '';
  let reviewedSessions: SubscriptionSessionReview[] = [];

  if (subscriptionSessionReview) {
    try {
      reviewedSessions = JSON.parse(subscriptionSessionReview) as SubscriptionSessionReview[];
    } catch (error) {
      console.error(`Error in getReviewedSessions: ${(error as Error).message}`);
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  return reviewedSessions;
};

export const saveReviewedSessions = (reviewedSessions: SubscriptionSessionReview[]): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(reviewedSessions));
};

export const mergeSession = (sessionId: string, sessionData: Partial<SubscriptionSessionReview>): void => {
  const reviewedSessions = getReviewedSessions();
  const sessionIndex = reviewedSessions.findIndex((session) => session.sessionId === sessionId);

  const newSession: SubscriptionSessionReview = {
    sessionId,
    sessionStartTimestamp: sessionData.sessionStartTimestamp ?? DateTime.local().toMillis(),
    isOpen: sessionData.isOpen ?? false,
    userId: sessionData.userId ?? '',
  };

  if (sessionIndex !== -1) {
    reviewedSessions[sessionIndex] = {
      ...reviewedSessions[sessionIndex],
      ...newSession,
    };
  } else {
    reviewedSessions.push(newSession);
  }

  saveReviewedSessions(reviewedSessions);
};
